import { render, staticRenderFns } from "./GroupbuyingsDetail.vue?vue&type=template&id=1c91ee66&"
import script from "./GroupbuyingsDetail.vue?vue&type=script&lang=js&"
export * from "./GroupbuyingsDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupbuyingsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports